import { render } from "./SampleFileComponent.vue?vue&type=template&id=214d21f9"
import script from "./SampleFileComponent.vue?vue&type=script&lang=js"
export * from "./SampleFileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/import/SampleFileComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "214d21f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('214d21f9', __exports__)) {
    api.reload('214d21f9', __exports__)
  }
  
  module.hot.accept("./SampleFileComponent.vue?vue&type=template&id=214d21f9", () => {
    api.rerender('214d21f9', render)
  })

}


export default __exports__